
<template>
    <div>

        <transition name="slide-fade">
            <div v-if="loadingScreen" class="fixed top-0 left-0 w-full h-[100dvh] flex justify-center items-center z-40">
                <div class="relative max-h-full p-8">
                    <div
                        class="relative bg-white rounded-lg shadow-md md:shadow-2xl duration-300 flex items-center justify-center w-[180px]">
                        <div class="emojiloader"></div>
                    </div>
                </div>
            </div>
        </transition>

        <transition name="slide-fade">
            <div v-if="!loadingScreen" class="w-screen min-h-screen flex justify-center items-center align-middle">
                <div class="h-full max-w-2xl w-full md:m-4">
                    <div class="h-full w-full relative">
                        <div class="mx-auto md:px-4 h-full">
                            <div
                                class="bg-white min-h-[630px] rounded-3xl md:rounded-2xl shadow-2xl p-10 flex flex-col w-full items-center justify-center">
                                <img class="max-h-[150px] max-w-[200px] mx-auto mb-10" :src="this.client_logo"
                                    :alt="JSON.parse(this.client).name + ' logo'">

                                <h2 class="text-2xl mb-2 text-gray-800 text-center font-bold"
                                    v-if="JSON.parse(bookingdata)['bookings'].length">
                                    {{ $t('Hi') }} {{ JSON.parse(bookingdata)['guestFirstName'] }},
                                </h2>
                                <h2 class="text-2xl mb-2 text-gray-800 text-center font-bold" v-else>
                                    {{ $t('Payment for') }}:
                                </h2>
                                <h3 class="md:text-xl mb-4 text-gray-600 text-center"
                                    v-if="forbooking && JSON.parse(bookingdata)['bookings'].length == 1">
                                    {{ $t('Please confirm your stay at') }} {{ JSON.parse(room_info)[Object.keys(JSON.parse(room_info))[0]]['name'] }}
                                    {{ $t('by completing the below payment') }}.
                                </h3>
                                <h3 v-else-if="description != '' && !JSON.parse(bookingdata)['bookings'].length">
                                    {{ capitalized($t(description)) }}
                                </h3>

                                <span v-if="description != '' && JSON.parse(bookingdata)['bookings'].length > 0"
                                    class="text-center mb-4 primary_color">
                                    {{ capitalized($t(description)) }}
                                </span>


                                <div
                                    class="rounded-md w-full primary_color font-bold text-3xl md:text-4xl p-4 pt-0 mb-4 text-center">
                                    € {{ totalPrice }}
                                </div>

                                <div v-if="bookingdata" v-for="(booking) in JSON.parse(bookingdata)['bookings']"
                                    class="w-full">
                                    <div
                                        class="w-full flex flex-col space-y-4 sm:space-y-0 sm:flex-row justify-start items-center sm:space-x-4 mb-4">
                                        <div class="flex flex-row bg-white rounded w-full">
                                            <div
                                                class="flex items-center justify-center flex-shrink-0 h-12 w-12 rounded-xl primary_background_light primary_color">
                                                <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" fill="currentColor"
                                                    viewBox="0 0 640 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
                                                    <path
                                                        d="M.3 166.9L0 68C0 57.7 9.5 50.1 19.5 52.3l35.6 7.9c10.6 2.3 19.2 9.9 23 20L96 128l127.3 37.6L181.8 20.4C178.9 10.2 186.6 0 197.2 0h40.1c11.6 0 22.2 6.2 27.9 16.3l109 193.8 107.2 31.7c15.9 4.7 30.8 12.5 43.7 22.8l34.4 27.6c24 19.2 18.1 57.3-10.7 68.2c-41.2 15.6-86.2 18.1-128.8 7L121.7 289.8c-11.1-2.9-21.2-8.7-29.3-16.9L9.5 189.4c-5.9-6-9.3-14-9.3-22.5zM32 448H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32zm96-80a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm128-16a32 32 0 1 1 0 64 32 32 0 1 1 0-64z" />
                                                </svg>
                                            </div>
                                            <div class="flex flex-col flex-grow ml-4">
                                                <div class="text-sm text-gray-500">{{ $t('Check-in') }}
                                                </div>
                                                <div class="font-bold text-sm">
                                                    {{ getCheckin(booking.firstNight) }}
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            class="flex flex-row bg-white rounded w-full sm:flex-row-reverse sm:justify-end">
                                            <div
                                                class="flex items-center justify-center flex-shrink-0 h-12 w-12 rounded-xl primary_background_light primary_color">
                                                <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" fill="currentColor"
                                                    viewBox="0 0 640 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
                                                    <path
                                                        d="M381 114.9L186.1 41.8c-16.7-6.2-35.2-5.3-51.1 2.7L89.1 67.4C78 73 77.2 88.5 87.6 95.2l146.9 94.5L136 240 77.8 214.1c-8.7-3.9-18.8-3.7-27.3 .6L18.3 230.8c-9.3 4.7-11.8 16.8-5 24.7l73.1 85.3c6.1 7.1 15 11.2 24.3 11.2H248.4c5 0 9.9-1.2 14.3-3.4L535.6 212.2c46.5-23.3 82.5-63.3 100.8-112C645.9 75 627.2 48 600.2 48H542.8c-20.2 0-40.2 4.8-58.2 14L381 114.9zM0 480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32z" />
                                                </svg>
                                            </div>
                                            <div class="flex flex-col flex-grow ml-4 sm:mr-4">
                                                <div class="text-sm text-gray-500 sm:text-right">{{ $t('Check-out') }}
                                                </div>
                                                <div class="font-bold text-sm sm:text-right">
                                                    {{ getCheckout(booking.lastNight) }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="rounded-md w-full primary_background_light p-4 mb-4">
                                        <div class="flex w-full justify-between items-end">
                                            <div class="flex flex-col ">
                                                <div class="text-sm">
                                                    <strong class="text-sm">{{ $t('Booking reference') }}:</strong> {{
                                                        booking.id }}
                                                </div>
                                                <div class="text-sm">
                                                    <strong class="text-sm">{{ $t('Guest name') }}:</strong> {{
                                                        booking.guestFirstName }} {{ booking.guestName }}
                                                </div>
                                                <div class="text-sm">
                                                    <strong class="text-sm">{{ $t('Email') }}:</strong> {{
                                                        booking.guestEmail }}
                                                </div>

                                                <div class="text-sm">
                                                    <strong class="text-sm">{{ $t('Adults') }}:</strong> {{ booking.numAdult
                                                    }}
                                                </div>
                                                <div class="text-sm" v-if="booking.numChild && booking.numChild != 0">
                                                    <strong class="text-sm">{{ $t('Children') }}:</strong> {{
                                                        booking.numChild
                                                    }}
                                                </div>
                                                <div class="text-sm" v-if="JSON.parse(room_info)">
                                                    {{ JSON.parse(room_info)[booking.roomId]['name'] }}
                                                </div>
                                                <div class="text-sm" v-if="JSON.parse(prop_info)">
                                                    {{ JSON.parse(prop_info)[booking.propId]['name'] }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <stripe-element-payment class="w-full" v-if="elementOptionsComp.clientSecret"
                                    v-show="!stripeLoading" ref="paymentRef" :pk="stripe_key"
                                    :elements-options="elementOptionsComp" :create-options="createStripeOptions"
                                    :confirm-params="confirmParams" :metadata="bookingdata"
                                    @error="stripeErrorListener($event)" @element-ready="stripeReady()" />

                                <div role="status" v-show="stripeLoading"
                                    class="w-full  divide-y divide-gray-200 animate-pulse animate-out">
                                    <div class="flex items-center justify-between pb-4 space-x-2">

                                        <div class="border-gray-200 border rounded-md shadow px-3 py-4 w-full">
                                            <div class="h-2.5 bg-gray-300 rounded-full w-16 mb-2.5"></div>
                                            <div class="w-24 h-2 bg-gray-200 rounded-full"></div>
                                        </div>
                                        <div class="border-gray-200 border rounded-md  shadow px-3 py-4 w-full">
                                            <div class="h-2.5 bg-gray-300 rounded-full w-16 mb-2.5"></div>
                                            <div class="w-24 h-2 bg-gray-200 rounded-full"></div>
                                        </div>
                                        <div class="border-gray-200 border rounded-md  shadow px-3 py-4 w-full">
                                            <div class="h-2.5 bg-gray-300 rounded-full w-16 mb-2.5"></div>
                                            <div class="w-24 h-2 bg-gray-200 rounded-full"></div>
                                        </div>
                                        <div class="border-gray-200 border rounded-md  shadow px-3 py-4 w-full">
                                            <div class="h-2.5 bg-gray-300 rounded-full w-16 mb-2.5"></div>
                                            <div class="w-24 h-2 bg-gray-200 rounded-full"></div>
                                        </div>
                                    </div>
                                    <div
                                        class="flex items-center p-4 justify-between py-6 shadow border border-gray-200 rounded-md">
                                        <div>
                                            <div class="h-2.5 bg-gray-300 rounded-full w-24 mb-2.5"></div>
                                            <div class="w-32 h-2 bg-gray-200 rounded-full"></div>
                                        </div>
                                        <div class="h-2.5 bg-gray-300 rounded-full w-12"></div>
                                    </div>
                                </div>

                                <button @click="submitPayment()"
                                    class="flex-auto mt-8 focus:outline-none grow-0 border border-transparent py-2 px-5 rounded-xl shadow-md text-center font-medium transition duration-300 bg-gray-200 text-white cursor-not-allowed"
                                    :class="{ 'hover:shadow-xl primary_background text-white cursor-pointer hover:scale-105': !stripeLoading }">
                                    {{ $t('Pay') }} {{ $t('now') }}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>
<script>

import VueLoadImage from 'vue-load-image'
const formatter = new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' })
import _ from 'lodash';
import VueCookies from 'vue-cookies'
import { StripeElementPayment } from '@vue-stripe/vue-stripe';

import AppAccordion from "./items/AppAccordion.vue";
import filters from '../filters';
import moment from 'moment';

export default {
    components: {
        AppAccordion, StripeElementPayment
    },
    props: ['client', 'client_logo', 'stripe_key', 'amount', 'bookingdata', 'description', 'forbooking', 'room_info', 'prop_info'],
    data() {
        return {
            currentUrl: '',
            loadingStripe: 0,
            totalPrice: null,
            metadata: null,
            loadingScreen: true,
            stripeLoading: true,
            stripeError: false,
            createStripeOptions: {
                layout: {
                    type: 'tabs',
                    defaultCollapsed: false,
                    radios: false,
                    spacedAccordionItems: true
                },
                fields: {
                    billingDetails: {
                        name: 'never'
                    }
                }
            },
            elementsOptions: {
                appearance: {
                    theme: 'stripe',
                    variables: {
                        colorPrimary: JSON.parse(this.client).main_color,
                    },
                }, // appearance options
            },
            confirmParams: {
            },
        }
    },
    methods: {
        ...filters,
        stripeReady() {
            this.stripeLoading = false;
        },
        stripeErrorListener(e) {
            this.loadingScreen = false;
        },
        async generatePaymentIntent() {
            if (VueCookies.get('paymentIntent') && VueCookies.get('paymentIntent').amount && VueCookies.get('paymentIntent').amount == this.totalPrice && VueCookies.get('paymentIntent').id == JSON.parse(this.bookingdata)['bookingIds']) {
                try {
                    this.elementsOptions.clientSecret = VueCookies.get('paymentIntent').client_secret;
                    this.loadingStripe++;
                } catch (error) {
                    console.log(error)
                    VueCookies.remove("paymentIntent")
                    this.generatePaymentIntent()
                }
            } else {
                try {
                    let response = await fetch(
                        window.location.origin + "/api/payment/customInitiate",
                        {
                            method: 'POST',
                            headers: {
                                "X-Requested-With": "XMLHttpRequest",
                            },
                            body: JSON.stringify({
                                clientID: JSON.parse(this.client).id,
                                amount: this.totalPrice,
                                metadata: this.metadata,
                                description: this.description
                            })
                        }
                    );
                    const paymentIntent = await response.json();
                    this.elementsOptions.clientSecret = paymentIntent.client_secret;
                    VueCookies.set('paymentIntent', paymentIntent);
                    this.loadingStripe++;
                } catch (error) {
                    console.log(error);
                }
            }

            this.confirmParams = {
                return_url: window.location.origin + '/book/'+JSON.parse(this.client).id+'/result', // success url
                payment_method_data: {
                    billing_details: {
                        name: (JSON.parse(this.bookingdata).length ? JSON.parse(this.bookingdata)['guestFirstName'] : this.description) ? this.description : 'no name',
                        email: JSON.parse(this.bookingdata).length ? JSON.parse(this.bookingdata)['email'] : '',
                    },
                    metadata: this.metadata,
                }
            }
        },
        getCheckin(date) {
            return moment(date, 'YYYY-MM-DD').locale(this.$i18n.locale).format('Do MMM, Y');
        },
        getCheckout(date) {
            return moment(date, 'YYYY-MM-DD').add(1, 'day').locale(this.$i18n.locale).format('Do MMM, Y');
        },
        submitPayment() {
            this.$refs.paymentRef.submit();
            setTimeout(() => {
                if (this.stripeError) {
                    this.loadingScreen = false
                } else {
                    this.loadingScreen = true
                }
            }, 100);
        }
    },
    computed: {
        elementOptionsComp: function () {
            this.loadingStripe
            return this.elementsOptions
        },

    },
    created() {
        var self = this;
        window.addEventListener("pageshow", function () {
            self.loadingScreen = false;
        }, false);

        this.currentUrl = window.location.origin;
        if (this.forbooking) {
            this.metadata = {
                'id': JSON.parse(this.bookingdata)['bookingIds'] ?? [],
                'email': JSON.parse(this.bookingdata)['email'] ?? [],
                'client': JSON.parse(this.bookingdata)['client'] ?? JSON.parse(this.client).name,
                'clientID': JSON.parse(this.bookingdata)['clientID'] ?? JSON.parse(this.client).id
            };

        }

        if ('bookings' in JSON.parse(this.bookingdata)) {
            var price = 0
            JSON.parse(this.bookingdata)['bookings'].forEach(key => {
                price += Number(key['price']);
            });

            this.totalPrice = price;
        } else if (this.amount) {
            this.totalPrice = this.amount
        } else {
            this.totalPrice = null
        }

        this.generatePaymentIntent();
    },
};
</script>